import { Reducer } from 'redux';
import { UtilsState, UtilsTypes } from './types';

const INITIAL_STATE: UtilsState = {
  error: false,
  loading: false,
};

const reducer: Reducer<UtilsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // DISPATCH ACTIONS CHAIN
    case UtilsTypes.DISPATCH_ACTIONS_CHAIN_REQUEST:
      return { ...state, loading: true, error: false };
    case UtilsTypes.DISPATCH_ACTIONS_CHAIN_SUCCESS:
      return { ...state, loading: false, error: false };
    case UtilsTypes.DISPATCH_ACTIONS_CHAIN_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default reducer;
